'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';
import { useIsMounted } from 'usehooks-ts';
import { DEFAULT_LISTING_PART_VARIANTS, LISTING_URL_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingUrl } from '@/features/listing/types/listing-types';
import SearchPlaceSelect from '@/features/place/components/search-place-select/search-place-select';
import { getCookieCurrentPlace, setCookieCurrentPlace } from '@/features/place/cookies/cookie-current-place';
import { deleteCookieLastSearchedPlaces, setCookieLastSearchedPlaces } from '@/features/place/cookies/cookie-last-searched-places';
import { getCookieUserCoordinates, setCookieUserCoordinates } from '@/features/place/cookies/cookie-user-coordinates';
import getUserCoordinates from '@/features/place/requests/get-user-coordinates';
import { type Place } from '@/features/place/types/place-types';
import placeNameToUrl from '@/features/place/utils/place-name-to-url';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
interface SearchPlaceProps {
  lastSearchedPlaces: Place[] | null;
  currentPlace: Place | null;
  isNeedMoveForwardButton?: boolean;
  moveForwardButtonCallback?: () => void;
  isMainPage?: boolean;
  isOptionNavigateToPlace?: boolean;
}
export default function SearchPlace(props) {
  const $ = _c(27);
  const {
    currentPlace,
    isMainPage,
    isNeedMoveForwardButton,
    isOptionNavigateToPlace: t0,
    lastSearchedPlaces,
    moveForwardButtonCallback
  } = props;
  const isOptionNavigateToPlace = t0 === undefined ? false : t0;
  const router = useRouter();
  const locale = useLocale();
  const params = useParams();
  const isMounted = useIsMounted();
  let t1;
  if ($[0] !== lastSearchedPlaces) {
    t1 = lastSearchedPlaces ?? [];
    $[0] = lastSearchedPlaces;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [placeOptions, setPlaceOptions] = useState(t1);
  const paramsListingType = params.listingType ?? "rooms-for-rent";
  const currentListingType = LISTING_URL_PART_VARIANTS[paramsListingType as ListingUrl];
  const listingTypeSlug = DEFAULT_LISTING_PART_VARIANTS[currentListingType];
  let t2;
  if ($[2] !== currentPlace || $[3] !== listingTypeSlug) {
    t2 = () => {
      const userCoordinatesCookie = getCookieUserCoordinates();
      const currentPlaceCookie = getCookieCurrentPlace();
      if (!userCoordinatesCookie) {
        getUserCoordinates().then(_temp).catch(_temp2);
      }
      if (currentPlace?.fullName && currentPlaceCookie?.fullName !== currentPlace.fullName) {
        setCookieCurrentPlace({
          ...currentPlace,
          listingTypeUrl: listingTypeSlug
        });
        deleteCookieLastSearchedPlaces();
        setPlaceOptions([]);
      }
    };
    $[2] = currentPlace;
    $[3] = listingTypeSlug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentPlace || $[6] !== isMounted || $[7] !== listingTypeSlug) {
    t3 = [currentPlace, isMounted, listingTypeSlug];
    $[5] = currentPlace;
    $[6] = isMounted;
    $[7] = listingTypeSlug;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== listingTypeSlug || $[10] !== locale || $[11] !== router) {
    t4 = userCurrentPlace => {
      setCookieCurrentPlace({
        ...userCurrentPlace,
        listingTypeUrl: listingTypeSlug
      });
      const redirectSearchResultsLink = ROUTER_LINKS.searchResults(listingTypeSlug, placeNameToUrl(userCurrentPlace.fullName));
      router.push(redirectSearchResultsLink, {
        locale
      });
    };
    $[9] = listingTypeSlug;
    $[10] = locale;
    $[11] = router;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleShowNearMeClick = t4;
  let t5;
  if ($[13] !== isOptionNavigateToPlace || $[14] !== listingTypeSlug || $[15] !== locale || $[16] !== moveForwardButtonCallback || $[17] !== router) {
    t5 = (place, foundPlaces) => {
      if (place) {
        setCookieCurrentPlace({
          ...place,
          listingTypeUrl: listingTypeSlug
        });
        if (foundPlaces) {
          setCookieLastSearchedPlaces(foundPlaces);
        }
        if (!isOptionNavigateToPlace && moveForwardButtonCallback) {
          moveForwardButtonCallback();
        } else {
          const redirectSearchResultsLink_0 = ROUTER_LINKS.searchResults(listingTypeSlug, placeNameToUrl(place.fullName));
          router.push(redirectSearchResultsLink_0, {
            locale
          });
        }
      }
    };
    $[13] = isOptionNavigateToPlace;
    $[14] = listingTypeSlug;
    $[15] = locale;
    $[16] = moveForwardButtonCallback;
    $[17] = router;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const onChangeSelect = t5;
  let t6;
  if ($[19] !== currentPlace || $[20] !== handleShowNearMeClick || $[21] !== isMainPage || $[22] !== isNeedMoveForwardButton || $[23] !== moveForwardButtonCallback || $[24] !== onChangeSelect || $[25] !== placeOptions) {
    t6 = <SearchPlaceSelect onShowNearMeClick={handleShowNearMeClick} onChangeSelect={onChangeSelect} options={placeOptions} isNeedMoveForwardButton={isNeedMoveForwardButton} isMainPage={isMainPage} currentPlace={currentPlace} moveForwardButtonCallback={moveForwardButtonCallback} />;
    $[19] = currentPlace;
    $[20] = handleShowNearMeClick;
    $[21] = isMainPage;
    $[22] = isNeedMoveForwardButton;
    $[23] = moveForwardButtonCallback;
    $[24] = onChangeSelect;
    $[25] = placeOptions;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}
function _temp2() {
  return null;
}
function _temp(userCurrentCoords) {
  if (userCurrentCoords) {
    setCookieUserCoordinates(userCurrentCoords);
  }
}